import COLUMN from '../../../../../DOM/table/TGROUP/ROW/column/COLUMN.js';
import { HTMLELEMENT } from '../../../../../../enums/HTMLELEMENT.js';
import { makeStruct } from '../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../enums/ModelData.js';
import { COLUMNTYPE } from '../../../../../../enums/COLUMNTYPE.js';
// Model Structure
export const tdAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['colspan'],
    ['rowspan']
]);
export const tdData = makeDataStruct([
    ['text'],
    ['datatype', COLUMNTYPE.VARCHAR],
    ['length', 255],
]);
export const tdModel = makeStruct([
    ['attributes', tdAttr],
    ['data', tdData]
]);
// Simplified Model
export function td(text, name, className, colspan, rowspan, datatype, length) {
    return {
        attributes: tdAttr(name, className, colspan, rowspan),
        data: tdData(text, datatype, length)
    };
}
/** A Row that exists inside a table */
export default class TD extends COLUMN {
    constructor(node, model) {
        super(node, HTMLELEMENT.TD, model);
    }
}
